import { render, staticRenderFns } from "./TheFooterInfo.vue?vue&type=template&id=76e5106f&scoped=true"
import script from "./TheFooterInfo.vue?vue&type=script&lang=js"
export * from "./TheFooterInfo.vue?vue&type=script&lang=js"
import style0 from "./TheFooterInfo.vue?vue&type=style&index=0&id=76e5106f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e5106f",
  null
  
)

export default component.exports